import React, { useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useLanguageContext } from "../context/LanguageContext";

function LanguageSwitcher() {
  const { language, setLanguage } = useLanguageContext();

  const handleLanguageChange = (event, newLanguage) => {
    if (newLanguage !== null) {
      setLanguage(newLanguage);
    }
  };

  return (
    <ToggleButtonGroup
      value={language}
      exclusive
      onChange={handleLanguageChange}
      sx={{
        display: "flex",
        borderRadius: "20px",
        backgroundColor: "#00555C",
        padding: "2px",
        marginLeft: "6px",
      }}
    >
      <ToggleButton
        value="EN"
        sx={{
          color: language === "EN" ? "white !important" : "#00555C !important",
          backgroundColor: language === "EN" ? "#00555C" : "white",
          fontWeight: "bold",
          borderRadius: "20px",
          border: "none",
          minHeight: "20px", // Reducing the height
          height: "20px", // Fixing the height
          padding: "0 8px", // Reducing the padding
          fontSize: "12px", // Adjusting font size
          "&:hover": {
            color: "white !important", // Ensure color is white on hover too
            backgroundColor: "#00555C", // Keep the background color consistent
          },
        }}
      >
        EN
      </ToggleButton>
      <ToggleButton
        value="ID"
        sx={{
          color: language === "ID" ? "white !important" : "#00555C !important",
          backgroundColor: language === "ID" ? "#00555C" : "white",
          fontWeight: "bold",
          borderRadius: "20px",
          border: "none",
          minHeight: "20px", // Reducing the height
          height: "20px", // Fixing the height
          padding: "0 8px", // Reducing the padding
          fontSize: "12px", // Adjusting font size
          "&:hover": {
            color: "white !important", // Ensure color is white on hover too
            backgroundColor: "#00555C", // Keep the background color consistent
          },
        }}
      >
        ID
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default LanguageSwitcher;
